import { CUSTOM_ICONS } from '@nexelem/icons';
import { useCallback } from 'react';
import { useCustomTranslation } from '../../../../hooks';
import { PERMS } from '../../../../routes/permissions';
import { PlanView, useProductionPlanQueryParams, AVAILABLE_QUERY_PARAMS } from '../hooks';
import { useAuthContext } from '../../../../providers/AuthProvider';
import { Toggle } from '@nexelem/components';

export const PlanViewToggle = () => {
  const { hasPermission } = useAuthContext();
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const hasKanbanBoardAccess = hasPermission(PERMS.PDB_6);
  const { queryParams, setQueryParams } = useProductionPlanQueryParams();

  const planView = queryParams.view;

  const onChangePlan = useCallback(
    (value: string) => {
      const newQueryParams = [{ key: AVAILABLE_QUERY_PARAMS.view, value }];
      setQueryParams(newQueryParams);
    },
    [setQueryParams],
  );

  return (
    hasKanbanBoardAccess && (
      <div className="flex items-center gap-2">
        <span className="text-s11-sb text-text-secondary uppercase">{tWrapper('view')}</span>
        <Toggle.Root value={planView} onChange={onChangePlan}>
          <Toggle.Button StartIcon={<CUSTOM_ICONS.Gantt />} value={PlanView.GANTT}>
            Gantt
          </Toggle.Button>
          <Toggle.Button StartIcon={<CUSTOM_ICONS.Kanban />} value={PlanView.KANBAN}>
            Kanban
          </Toggle.Button>
        </Toggle.Root>
      </div>
    )
  );
};
